import React from 'react';

import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Button, Typography } from '@mui/material';

import { tokens } from '../theme';
import CallBand from './stitch/CallBand';
import { cardSx } from './stitch/Section';

// Closing of the Stitch case-study and insight screens: the capability statement card,
// then the navy call band.
function CaseStudyNextSteps() {
  return (
    <>
      <Box
        component='section'
        aria-labelledby='capability-statement'
        sx={{
          ...cardSx,
          mt: { xs: 6, md: 8 },
          p: { xs: 3, md: 5 },
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { md: 'center' },
          justifyContent: 'space-between',
          gap: 3,
        }}
      >
        <Box sx={{ maxWidth: '42rem' }}>
          <Typography
            variant='labelCaps'
            component='p'
            sx={{ color: tokens.accentText }}
          >
            Capability statement
          </Typography>
          <Typography
            id='capability-statement'
            component='h2'
            variant='h3'
            sx={{ mt: 1 }}
          >
            Explore our CMS capabilities
          </Typography>
          <Typography
            variant='body2'
            sx={{ mt: 1.5 }}
          >
            Review our approach to accessibility, permissions, integrations, deployment, and support
            in the CMS capability statement.
          </Typography>
        </Box>
        <Button
          href='/cms-capabilities'
          data-track='capability_statement'
          variant='contained'
          endIcon={<DescriptionOutlinedIcon aria-hidden='true' />}
          sx={{ flexShrink: 0, alignSelf: { xs: 'flex-start', md: 'center' } }}
        >
          View CMS capability statement
        </Button>
      </Box>

      <CallBand
        id='publishing-workflow'
        label='Talk with the principal'
        title='Have a publishing workflow to improve?'
        text='Book a 20-minute call, or send a message about the workflow you want to improve.'
        secondary={{ label: 'Contact us', to: '/contact-us' }}
      />
    </>
  );
}

export default CaseStudyNextSteps;
